(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["raptus-animated-number"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('raptus-count-up')) {
      return;
    }

    class RaptusCountUp extends HTMLElement {
      connectedCallback() {
        if (this.isInitialised) {
          return;
        }

        this.isInitialised = true;

        this.valueElement = this.querySelector(
          '[data-counter-value]'
        );

        if (!this.valueElement) {
          return;
        }

        this.startValue = this.parseNumber(
          this.dataset.start,
          0
        );

        this.endValue = this.parseNumber(
          this.dataset.end,
          0
        );

        this.decimals = this.parseInteger(
          this.dataset.decimals,
          0
        );

        this.duration =
          this.parseNumber(this.dataset.duration, 2) * 1000;

        this.delay =
          this.parseNumber(this.dataset.delay, 0) * 1000;

        this.easing =
          this.dataset.easing || 'ease-out';

        this.useGrouping =
          this.dataset.grouping === 'true';

        this.replay =
          this.dataset.replay === 'true';

        this.threshold = Math.min(
          Math.max(
            this.parseNumber(
              this.dataset.threshold,
              0.25
            ),
            0
          ),
          1
        );

        this.locale =
          this.dataset.locale ||
          document.documentElement.lang ||
          'en';

        this.hasAnimated = false;
        this.isRunning = false;
        this.animationFrame = null;
        this.delayTimer = null;

        this.reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        if (this.reducedMotion) {
          this.renderValue(this.endValue);
          this.hasAnimated = true;
          return;
        }

        this.renderValue(this.startValue);

        if (!('IntersectionObserver' in window)) {
          this.startAnimation();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.startAnimation();

                if (!this.replay && this.observer) {
                  this.observer.unobserve(this);
                }
              } else if (this.replay) {
                this.resetAnimation();
              }
            });
          },
          {
            threshold: this.threshold
          }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.cancelAnimation();

        if (this.observer) {
          this.observer.disconnect();
        }

        this.isInitialised = false;
      }

      parseNumber(value, fallback) {
        const parsedValue = Number.parseFloat(value);

        return Number.isFinite(parsedValue)
          ? parsedValue
          : fallback;
      }

      parseInteger(value, fallback) {
        const parsedValue = Number.parseInt(value, 10);

        return Number.isFinite(parsedValue)
          ? parsedValue
          : fallback;
      }

      startAnimation() {
        if (
          this.isRunning ||
          (!this.replay && this.hasAnimated)
        ) {
          return;
        }

        this.cancelAnimation();
        this.hasAnimated = true;

        if (this.delay > 0) {
          this.delayTimer = window.setTimeout(() => {
            this.delayTimer = null;
            this.runAnimation();
          }, this.delay);
        } else {
          this.runAnimation();
        }
      }

      runAnimation() {
        if (this.duration <= 0) {
          this.renderValue(this.endValue);
          this.isRunning = false;
          return;
        }

        this.isRunning = true;

        const animationStart = performance.now();
        const numberDifference =
          this.endValue - this.startValue;

        const updateNumber = (currentTime) => {
          const elapsedTime =
            currentTime - animationStart;

          const progress = Math.min(
            elapsedTime / this.duration,
            1
          );

          const easedProgress =
            this.getEasedProgress(progress);

          const currentValue =
            this.startValue +
            numberDifference * easedProgress;

          this.renderValue(currentValue);

          if (progress < 1) {
            this.animationFrame =
              requestAnimationFrame(updateNumber);
          } else {
            this.renderValue(this.endValue);
            this.animationFrame = null;
            this.isRunning = false;
          }
        };

        this.animationFrame =
          requestAnimationFrame(updateNumber);
      }

      resetAnimation() {
        this.cancelAnimation();
        this.renderValue(this.startValue);
        this.hasAnimated = false;
        this.isRunning = false;
      }

      cancelAnimation() {
        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
        }

        if (this.delayTimer) {
          clearTimeout(this.delayTimer);
          this.delayTimer = null;
        }

        this.isRunning = false;
      }

      getEasedProgress(progress) {
        switch (this.easing) {
          case 'linear':
            return progress;

          case 'ease-in':
            return progress * progress * progress;

          case 'ease-in-out':
            return progress < 0.5
              ? 4 * progress * progress * progress
              : 1 -
                  Math.pow(-2 * progress + 2, 3) / 2;

          case 'ease-out':
          default:
            return 1 - Math.pow(1 - progress, 3);
        }
      }

      renderValue(value) {
        const formatter = new Intl.NumberFormat(
          this.locale,
          {
            useGrouping: this.useGrouping,
            minimumFractionDigits: this.decimals,
            maximumFractionDigits: this.decimals
          }
        );

        this.valueElement.textContent =
          formatter.format(value);
      }
    }

    customElements.define(
      'raptus-count-up',
      RaptusCountUp
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
